import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { _AbcFileUploaderComponent, _AbcButtonComponent } from '@barthauer/abc/ui-components';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { CordovaService } from '@barthauer/abc/core';

@Component({
  selector: 'lib-media-selection',
  standalone: true,
  imports: [FlexLayoutModule, _AbcFileUploaderComponent, _AbcButtonComponent],
  templateUrl: './media-selection.component.html',
  styleUrl: './media-selection.component.scss',
})
export class MediaSelectionComponent implements OnInit {
  @Output() onFilesSelected = new EventEmitter<File[]>();
  @Output() onCloseDemand = new EventEmitter<void>();
  protected selectedFiles: File[] = [];
  protected res: ResourceSet;

  protected accept: string;

  constructor(
    private resourceManagerService: ResourceManagerService,
    cordovaService: CordovaService,
  ) {
    if (cordovaService.platform.isIOSOrIPadOS) {
      this.accept = 'video/*, image/*';
    }
  }

  async ngOnInit() {
    this.res = await this.resourceManagerService.getResourceSet('abc-media-gallery');
  }
}
